var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15.574,
    viewBox: "0 0 14 15.574",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "estate",
    d: "M16.222,6.661h0L11.555,2.57a2.333,2.333,0,0,0-3.111,0L3.778,6.661A2.333,2.333,0,0,0,3,8.419v6.8A2.333,2.333,0,0,0,5.333,17.55h9.333A2.333,2.333,0,0,0,17,15.217V8.411a2.333,2.333,0,0,0-.778-1.75Zm-4.667,9.333H8.444V12.106a.778.778,0,0,1,.778-.778h1.556a.778.778,0,0,1,.778.778Zm3.889-.778a.778.778,0,0,1-.778.778H13.111V12.106a2.333,2.333,0,0,0-2.333-2.333H9.222a2.333,2.333,0,0,0-2.333,2.333v3.889H5.333a.778.778,0,0,1-.778-.778V8.411a.778.778,0,0,1,.264-.583L9.487,3.745a.778.778,0,0,1,1.027,0L15.18,7.828a.778.778,0,0,1,.264.583Z",
    transform: "translate(-3 -1.976)",
    fill: "#8c90a4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.91847b32643dbee8a8e065333157e3ab.svg";
export { ForwardRef as ReactComponent };